var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63638 42.9998C9.19698 42.9998 11.2728 40.9602 11.2728 38.4442C11.2728 35.9283 9.19698 33.8887 6.63638 33.8887C4.07578 33.8887 2 35.9283 2 38.4442C2 40.9602 4.07578 42.9998 6.63638 42.9998Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63611 12.6296V33.8889M22.0907 14.1482L15.9089 8.07408L22.0907 2",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63638 12.6297C9.19698 12.6297 11.2728 10.5901 11.2728 8.07411C11.2728 5.55815 9.19698 3.51855 6.63638 3.51855C4.07578 3.51855 2 5.55815 2 8.07411C2 10.5901 4.07578 12.6297 6.63638 12.6297Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3634 42.9998C33.924 42.9998 35.9998 40.9602 35.9998 38.4442C35.9998 35.9283 33.924 33.8887 31.3634 33.8887C28.8028 33.8887 26.7271 35.9283 26.7271 38.4442C26.7271 40.9602 28.8028 42.9998 31.3634 42.9998Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4546 8.07422H25.5683C27.1053 8.07422 28.5794 8.67417 29.6663 9.74208C30.7531 10.81 31.3637 12.2584 31.3637 13.7687V33.889",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProspect);
export default __webpack_public_path__ + "static/media/icon-prospect.f15c50a555976632b1a623ef2401fa4e.svg";
export { ForwardRef as ReactComponent };